export const DATA_TEST_ID = {
  HIDE_BUTTON: 'hide-button',
  RESTORE_BUTTON: 'restore-button',
  CONFIRM_MODAL_CROSS: 'confirm-modal-cross',
  CONFIRM_MODAL: 'confirm-modal',
  CONFIRM_MODAL_CLOSE: 'confirm-modal-close',
  CONFIRM_MODAL_SUBMIT: 'confirm-modal-submit',
  CONFIRM_MODAL_HIDE_ONLY: 'confirm-modal-hide-only',
  CONFIRM_MODAL_TITLE: 'confirm-modal-title',
  CONFIRM_MODAL_BODY: 'confirm-modal-body',
  CONFIRM_MODAL_OPTIONS: 'confirm-modal-options',
  CONFIRM_MODAL_OPTION_KEEP_RULES: 'confirm-modal-option-keep-rules',
  CONFIRM_MODAL_OPTION_DELETE_RULES: 'confirm-modal-option-delete-rules',
};

/** How hide interacts with existing logic that references the answer. */
export const HIDE_ANSWER_LOGIC_MODE = {
  /** Prune all Answer/Visibility refs (legacy hide-as-soft-delete). */
  REMOVE_RULES: 'removeRules',
  /**
   * Keep rules: every rule that references the answer is kept, on the same
   * question and on remote ones, and is highlighted in red for review.
   */
  KEEP_RULES: 'keepRules',
};
